import React, { useState, useEffect } from "react";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Link } from "react-router-dom";
import { ADMIN_ADD_USER_URL } from "../../constants/url";
import { ERR_POSTING, SUCC_ADD_CUS, SUCC_ALERT_TITLE } from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";
const AddCustomer = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    mobile: "",
    error: "",
    header: "Add Customer",
    success: false,
    crops: [],
    message: "",
    imageName: "",
    type_id: "",
    type: "add",
    image: "",
    removed: false,
  });
  const { name, mobile, email, header } = values;
  useEffect(() => {}, []);

  const onSubmit = (event) => {
    event.preventDefault();
  
   const requestUrl = `${ADMIN_ADD_USER_URL}?mobile_no=${mobile}&refCode=&name=${name}&email=${email}&country_code=`
   privateApiCall(requestUrl,"GET")
      .then(
        (res) => {
          if (res.data.status) {
            Swal.fire({
              title: `${SUCC_ALERT_TITLE}`,
              text: `${SUCC_ADD_CUS}`,
              icon: "success",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                document.location = "/admin/customer";
              }
            });
          } else {
            Swal.fire({
              title: "Error",
              text: res.data.message,
              icon: "error",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
              }
            });
          }
        },
        (err) => {
          Swal.fire({
            title: `${ERR_POSTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
  };
  
  const handleChange = (name) => (e) => {
    setValues({ ...values, error: false, [name]: e.target.value });
  };
  const dataTable = () => {
    return (
      <div id="wrapper">
        <Topbar backgroundColor="#769A0F" />
        <Sidebar type="profiles" />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          {" "}
                          <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item active">Add Customer</li>
                      </ol>
                    </div>
                    <h4 className="page-title">Add Customer</h4>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card-box" style={{ paddingBottom: "50px" }}>
                    <div className="form-group form-inline">
                      <label>{header}</label>
                    </div>

                    <form onSubmit={onSubmit}>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          placeholder="Name  "
                          id="name"
                          name="name"
                          onChange={handleChange("name")}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={mobile}
                          placeholder="Mobile Number"
                          id="mobile"
                          name="mobile"
                          onChange={handleChange("mobile")}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={email}
                          placeholder="Email Id"
                          id="email"
                          name="email"
                          onChange={handleChange("email")}
                          required
                        />
                      </div>

                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return <React.Fragment>{dataTable()}</React.Fragment>;
};

export default AddCustomer;
